module.exports = __webpack_public_path__ + "static/media/australia-01.d3382ba0.png";